<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="white" fill-opacity="0.05"/>
<rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="white" stroke-opacity="0.15" stroke-width="0.5"/>
<path d="M10.75 16.0117H21.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 10.7617V21.2617" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
